import React, { memo } from 'react'

import { Icon, ChevronDown, ChevronUp, Divider } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

const size = { height: '14px', width: '14px' }

function AdvancedSettingsTrigger({ isExpanded, onClick: handleClick }) {
  return (
    <button
      type="button"
      onClick={handleClick}
      className="advanced-settings__trigger"
      aria-expanded={isExpanded}
    >
      <span className="advanced-settings__trigger-label">Advanced settings</span>
      <Divider />
      <Icon
        svgComponent={isExpanded ? ChevronUp : ChevronDown}
        size={size}
        color="dark"
        notSpaced
      />
    </button>
  )
}

AdvancedSettingsTrigger.propTypes = {
  isExpanded: bool.isRequired,
  onClick: func.isRequired,
}

export default memo(AdvancedSettingsTrigger)
